import { render, staticRenderFns } from "./BankListGateway.vue?vue&type=template&id=0a5631f6&lang=pug"
import script from "./BankListGateway.vue?vue&type=script&lang=js"
export * from "./BankListGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports